import React, { Component } from 'react';
import * as $ from 'jquery';
import axios from 'axios';
import moment from 'moment-timezone';
import { MENU } from '../../dashboard/Sidebar.js';
import { translate } from 'react-i18next';
import { ERRORS } from '../../App.js';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import Footer from '../Footer.js';
import Navbar from '../Navbar.js';

export const STATUS = {
  PENDING: 1,
  PAID: 2,
  PROCESS: 3
};

let cancelToken;
let state;
let tokenSession;

class PromotionContainer extends Component {

  constructor(props) {
    super(props);
    const init_state = { error: "" };
    this.state = init_state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    $(window).resize(this.resize);
    this.resize();
  }
  componentWillUnmount() {
      $(window).off("resize", this.resize);
    }
  resize = () => {
    $('#content-wrapper').css({
      paddingTop: this.props.getNavbarHeight()
    });
  }

  handleClearError = () => {
    this.setState({
      error: "",
      promotion_success: ""
    });
  }

  renderError = () => {
    return(
      <div className="form-group">
        <div className="col-sm-8 col-sm-offset-2">
          <div className="alert alert-warning">
            {this.state.error}
          </div>
        </div>
      </div>
    );
  }

  renderPromotionButton = () => {
    return(
      <div className="row">
        <div className="col-lg-4 col-lg-offset-4">
          <button
            className={"btn btn-block btn-primary "}
            onClick={() => this.handlePromotionButtonClick()}
            type="button">
            {"DA CLICK AQUÍ PARA ACTIVAR LA PROMOCION"}
          </button>
        </div>
      </div>
    );
  }

  renderSuccessMessage = () => {
    return(
      <div><center>
        <h3>¡La promoción se ha aplicado exitosamente! Ingresa al portal de IOSFERA haciendo clic <a href="https://iosferaweb.iosoffices.com/">AQUÍ</a> para reservar tu sala de juntas</h3>
      </center></div>
    );
  }

  handlePromotionButtonClick = () => {
    this.registerPromotion({
      token_id: this.props.getTokenId(),
      folio_externo: this.props.match.params.external_token
    });
  }

  registerPromotion = (params) => {
    this.props.post(
      "/registrarPromocion",
      params,
      (response) => this.didRegisterPromotion(response),
      (error) => {
        this.setState({ error: 'Ocurrio un error al registrar la promoción. Por favor intenta nuevamente más tarde.' });
      },
      cancelToken
    );
  }

  didRegisterPromotion = (response) => {
    if(response.add_promotion_success){
      this.setState({ promotion_success: true });
    }else{
      this.setState({ error: response.msg });
    }
  }

  renderContent = () => {
    return(
        <div style={{paddingLeft: "5%",paddingRight: "5%"}}>
          <div><img width="100%" src='https://img.iosoffices.com/img/mails/cortesias_ios_banner.jpg' alt='Cortesias IOS'></img></div>
          <br></br>
          {this.state.error && this.renderError() }
          {this.state.promotion_success && this.renderSuccessMessage()}
          {!this.state.error && !this.state.promotion_success && this.renderPromotionButton()}
        </div>
    );
  }
  
  render() {
    const { t } = this.props;
    return(
      <div>
        <div style={{paddingBottom: "5%"}}>
          {this.renderNavbar()}
          <div id="content-wrapper">
            <h2 className="page-header" style={{paddingLeft: "5%"}}>Impulsa tu productividad, ¡Salas de Juntas disponibles para ti!</h2>
            {this.renderContent()}
          </div>
        </div>
        <div style={ footer_bottom }>{this.renderFooter()}</div>
      </div>
    );
  }

  renderNavbar = () => {
      return(
          <Navbar
          handleLanguageChange={this.props.handleLanguageChange}
          lang={this.props.lang} />
      );
  }

  renderFooter = () => {
      return(
          <Footer />
      );
  }

}

export default compose(
  translate('common'),
  withRouter
)(PromotionContainer);

const footer_bottom = {
  position: 'relative',
  bottom: 0,
  width: '100%'
}


// WEBPACK FOOTER //
// ./src/guest/promotion/PromotionContainer.js